import { storeKey } from "src/config/app-config";

export type HomepageRecommendationsConfig = {
  podId: string;
  title: string;
};

// The pod id shape cp-recommendations accepts, so a malformed id never leaves the browser.
const POD_ID_PATTERN = /^[a-zA-Z0-9_-]+$/;

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

/**
 * The homepage recommendations carousel for one store, read from the
 * web-homepage-recommendations Eppo flag: a JSON object keyed by store key, each entry
 * `{ "pod_id": "...", "title": "..." }`. Keyed by store because a Constructor pod belongs to one
 * store's index and each store serves one language. Returns null, and the carousel isn't shown,
 * when the flag is empty, the store has no entry, or its pod id or title is unusable.
 */
export const getHomepageRecommendationsConfig = (
  flagValue: unknown,
  store: string = storeKey
): HomepageRecommendationsConfig | null => {
  if (!isRecord(flagValue)) {
    return null;
  }

  const entry = flagValue[store];
  if (!isRecord(entry)) {
    return null;
  }

  const { pod_id: podId, title } = entry;
  if (typeof podId !== "string" || !POD_ID_PATTERN.test(podId)) {
    return null;
  }

  if (typeof title !== "string" || !title.trim()) {
    return null;
  }

  return { podId, title: title.trim() };
};
